import { ButtonMantine, Modal, ModalProps, Stack, Text } from 'ui';

interface Props extends ModalProps {}

export default function AddCardSuccessModal({ opened, onClose }: Props) {
  return (
    <Modal opened={opened} onClose={onClose}>
      <Stack gap="md" mb="10">
        <Text fz={'lg'} fw={700} lh="19px" c="#767676" ta="center">
          Card Connected!
        </Text>
        <Text>
          Great! You can use this card for in store and online cash back offers! Earn money for you
          and your cause!
        </Text>
        <ButtonMantine onClick={onClose}>Okay</ButtonMantine>
      </Stack>
    </Modal>
  );
}
